export default __webpack_public_path__ + "cbcf9b15e032620abc592f875c059dce.svg";